import { FetchResult } from '@apollo/client';

import {
  OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS,
  PERFORMANCE_EXPECTATION_CCC,
  PERFORMANCE_EXPECTATION_DCI,
  PERFORMANCE_EXPECTATION_ENG,
  PERFORMANCE_EXPECTATION_NOS,
  PERFORMANCE_EXPECTATION_SEP,
  Subject,
  Years,
} from 'global/constants';
import { InquisitiveUnitStatus } from 'global/graphql/scalars.type';
import {
  OutcomeError,
  OutcomeOption,
} from 'lib/form/tag-autocomplete/outcomes/tag-autocomplete-outcomes.constants';
import { AssessmentFragment } from '../graphql/lesson/__generated__/AssessmentFragment';
import { LessonFragment } from '../graphql/lesson/__generated__/LessonFragment';
import { OutcomesFragment } from '../graphql/outcomes/__generated__/OutcomesFragment';

// US NGSS Outcome Category colours
const ngssLightPink = '#F5B6B6';
const ngssLightBlue = '#BDCCE3';
const ngssLightOrange = '#F7D6B8';
const ngssLightGreen = '#D9E4C1';

export const PERFORMANCE_EXPECTATION_ENG_LABEL =
  'Connections to Engineering... (ENG)';

export type Outcome = OutcomesFragment & {
  description?: string;
  groupLabel?: string | null;
  metaInfo?: string | null;
  subLabel?: string | null;
};

export type Props = {
  savedOutcomes: Outcome[] | null;
  contentId: number;
  subject: Subject;
  years: Years[];
  addOutcome: (id: number, outcomeId: number) => Promise<FetchResult>;
  deleteOutcome: (id: number, outcomeId: number) => Promise<FetchResult>;
};

export type FormData = {
  [key: string]: OutcomeOption[];
};

export type OutcomeErrors = { [key: string]: OutcomeError[] };

export const OUTCOME_MODAL_SIZE = 560;

export type OutcomeLessons = LessonFragment & {
  outcomes: Outcome[] | null;
  performanceExpectations: Outcome[] | null;
};

export type OutcomeAssessments = AssessmentFragment & {
  outcomes: Outcome[] | null;
  performanceExpectations: Outcome[] | null;
};

export type OutcomeUnitData = {
  id: number;
  status: InquisitiveUnitStatus;
  lessons: OutcomeLessons[];
  assessments: OutcomeAssessments[];
  isIntegrated: boolean;
};

export type OutcomeGroup = {
  key: string;
  curriculum: string;
  version?: string;
  subLabel?: string | null;
  outcomes: Outcome[];
};

export const NGSS_OUTCOME_CATEGORY_COLOURS: {
  [key: string]: string;
} = {
  [OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS]: ngssLightPink,
  [PERFORMANCE_EXPECTATION_SEP]: ngssLightBlue,
  [PERFORMANCE_EXPECTATION_NOS]: ngssLightBlue,
  [PERFORMANCE_EXPECTATION_DCI]: ngssLightOrange,
  [PERFORMANCE_EXPECTATION_CCC]: ngssLightGreen,
  [PERFORMANCE_EXPECTATION_ENG]: ngssLightGreen,
};
